import './errorPage.scss';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '../../lib/PST.Web.Common/src/components/Button/Button';
import { Logo } from '../../lib/PST.Web.Common/src/components/Logo/Logo';

const ErrorPage = () => {
    const retry = () => window.location.reload();

    return (
        <div className="pst-error-page">
            <div className="content-container">
                <Logo large className="ep-logo" />
                <div className="info-container">
                    <div className="message">
                        <FormattedMessage
                            id="app.load.error.message"
                            defaultMessage={`L'application a rencontré une erreur pendant le chargement de la page.
                            Cliquez sur le bouton ci-dessous pour recharger.`}
                        />
                    </div>
                    <div className="retry-container">
                        <Button noTextTransform mango className="ep-button" onClick={retry}>
                            <FormattedMessage id="error.page.retry.button" defaultMessage="Réessayer" />
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

ErrorPage.propTypes = {};

export { ErrorPage };
